import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  return (
    <a
      data-testid="whatsapp-fab"
      href="https://wa.me/67077138966?text=Hello%20KINOS%2C%20I%20would%20like%20to%20ask%20about%20your%20products%20and%20services."
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="pulse-ring fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgba(37,211,102,0.4)] hover:scale-110 transition-transform duration-300"
    >
      <MessageCircle size={24} />
    </a>
  );
}
